import React, { useEffect } from 'react';
import Anime from 'react-anime';
import BackToHomeBtn from './BackToHomeBtn';
import '../styles/customScroll.css';
import '../styles/AboutPage.css';

const AboutPage = ({ returnBtn }) => {
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .custom-scroll::-webkit-scrollbar {
        height: 4px;
        background: transparent;
        border-radius: 4px;
      }
      .custom-scroll::-webkit-scrollbar-thumb {
        background: white;
        border-radius: 20px;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div style={{ overflow: 'hidden', position: 'fixed' }}>
      <div className="page-back-btn">
        <BackToHomeBtn handleClick={returnBtn} />
      </div>
      <Anime easing="easeOutCubic" opacity={[0, 1]} translateY={-30} duration={400} delay={300}>
        <div className="about-page">
          <Anime easing="easeOutCubic" opacity={[0, 1]} duration={500} delay={800}>
            <p className="page-tag">About Me</p>
          </Anime>

          <div
            className="about-scroll"
            style={{
              height: 'calc(100vh - 200px)',
              overflow: 'scroll',
              overflowX: 'hidden',
              scrollbarWidth: 'thin',
              scrollbarColor: 'rgba(255, 253, 253, 0.5) transparent',
            }}
          >
            <div className="page-content">
              <p>Hi there! <span className="hand-wave" role="img" aria-label="Hi..">👋</span></p>
              <h1>I'm Abdul Awal Arif.</h1>
              <p>And I'm a Software Engineer based in Bangladesh, specialized in Mobile Application Development with Flutter and Dart. I love developing tools/sites/apps that solve real problems or help make someone's life easier. I like impactful work.</p>
              <h3>Skills</h3>
              <p>My current skill set includes<strong>:</strong> <strong>Dart</strong>, <strong>JavaScript</strong>, <strong>Python</strong>, <strong>Flutter</strong>, <strong>Django</strong>, <strong>Node</strong>, <strong>Firebase</strong>, <strong>REST API</strong>, <strong>GraphQL</strong>, <strong>SQL</strong>, <strong>State Management</strong>, <strong>Git</strong>, <strong>OOP</strong>, <strong>MVVM</strong>, etc. And that's excluding all the common (yet sometimes complex) building/testing like <strong>Unit</strong>, <strong>Widget</strong> and <strong>Integration</strong> testing.</p>
              <p>However, I believe in tool agnostic skills. Being in an industry that moves at the speed of light, it sometimes doesn't matter what frameworks/tools I'm familiar with. Because tools/frameworks are so fickle these days that they can become obsolete within months! What matters more is how fast can I learn and make myself comfortable with newer technology. I'm a quick learner. I prioritize concepts over techniques.</p>
              <p>Simplicity, though overused (and sometimes misused) as a term, is something I really value. I like to build solutions that are simple yet interactive for the users.</p>
              <p>Besides coding, I'm also very passionate about running and reading. I feel like the world is a book that was given to me for exploring when I was born, and I don't wanna die before reading all the pages. I plan to become a nomad someday and explore the endless beauty that this planet homes.</p>
            </div>
          </div>
        </div>
      </Anime>
    </div>
  );
};

export default AboutPage;
